import {qualify, iconName} from '@packages/systems/wfdl-Qualified';
import {pluginName} from '../constants';
import {TypeImplementation} from '@packages/systems/wfdl';

export const CommercePriceType = TypeImplementation.Custom({
  render: () => null,
  icon: TypeImplementation.IconByName(qualify(pluginName, iconName('Price'))),
});
